// extracted by mini-css-extract-plugin
export default {"wrapper":"spinner_wrapper__ore4J"};